import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'mage-react-router';
import cms from '@moka-fe/cms';
import classNames from 'classnames';
import { uniqBy } from 'lodash';
import moment from 'moment';
import {
  Button,
  Dropdown,
  Empty,
  Icon,
  Loading,
  NewTable,
  Select,
  Spacing,
  TagSelect,
  Tooltip,
} from 'sugar-design';
import * as sdf from '@SDFoundation';

import JobManagerSelect from '../../_lib/JobManagerSelect';

import {
  DATE_FORMAT,
  HIRE_MODES,
  JOB_LIST_TYPES,
  JOB_LIST_TYPE_TO_JOB_STATUS,
} from '@/constants/common';
import { fetchJobList } from '@/redux/actions/jobs';
import { formatLocationListToShortStr } from '@/utils/common';
import { getI18n } from '@/utils/i18n';

import * as styles from './index.cm.styl';

const i18n = getI18n();

const JOB_LIST_STATUS_TABS = [
  {
    value: JOB_LIST_TYPES.OPEN,
    label: i18n.t`招聘中`,
  },
  {
    value: JOB_LIST_TYPES.CLOSED,
    label: i18n.t`已关闭`,
  },
];

class JobList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      jobFilterId: null,
      jobListType: JOB_LIST_TYPES.OPEN,
      jobList: [],
      jobManagerIds: [],
    };
  }

  componentDidMount() {
    const {
      params: { orgId },
    } = this.props.match;

    // 添加猎头合约之后，在列表中可能会出现两个相同的职位，但是是不同的合约，所以需要直接展示接口返回的列表，而不是通过idList去获取
    this.props.fetchJobList(orgId, (jobList) => this.setState({ jobList }));
  }

  onJobFilterChange = (value) => this.setState({ jobFilterId: value });

  onJobManagerFilterChange = (value) => this.setState({ jobManagerIds: value });

  onJobFilterStatusChange = (value) => {
    if (value) {
      this.setState({ jobListType: value, jobFilterId: null });
    }
  };

  onNumClick = (value) => (e) => {
    e.stopPropagation();
    this.props.onRedirectToApplication(value);
  };

  onRecommendClick = (row, type) => {
    const {
      params: { orgId },
    } = this.props.match;

    const { id, contractId } = row;

    return (e) => {
      e.stopPropagation();
      let targetUrl = `/headhunters/${orgId}/recommend/${id}/${contractId}`;
      if (type === 'rpo') {
        targetUrl = `/headhunters/${orgId}/recommend/${id}/${contractId}?headhunterType=rpo`;
      }
      this.props.history.push(targetUrl);
    };
  };

  onJobClick = (row) => {
    const {
      params: { orgId },
    } = this.props.match;
    const { id, contractId } = row;
    this.props.history.push(`/headhunters/${orgId}/job/${id}/${contractId}`);
  };

  createOnToggleJob = (id, isFollowed, contractId) => {
    const {
      params: { orgId },
    } = this.props.match;
    return (e) => {
      e.stopPropagation();
      if (isFollowed) {
        this.props.removeJobFollowed({
          jobId: id,
          orgId,
          contractId,
          callback: (jobList) => this.setState({ jobList }),
        });
      } else {
        this.props.addJobFollowed({
          jobId: id,
          orgId,
          contractId,
          callback: (jobList) => this.setState({ jobList }),
        });
      }
    };
  };

  render() {
    const { jobLoading } = this.props;
    const { jobFilterId, jobListType, jobList, jobManagerIds } = this.state;

    const jobFilterOptions = jobList.map((job) => {
      return {
        value: job.id,
        label: job.title,
        extra: formatLocationListToShortStr(job.locations, '·') + '·' + job.commitment,
        innerClassName: 'Select-option-job',
      };
    });

    const managerFilterOptions = uniqBy(
      jobList
        .map(({ managerId, managerName, managerEmail }) => ({
          managerId,
          managerName,
          managerEmail,
        }))
        .filter((option) => !!option.managerId),
      'managerId'
    );

    let filteredJobList = jobList;
    let currentStatusCount = 0;
    let otherStatusCount = 0;

    if (jobFilterId) {
      filteredJobList = filteredJobList.filter((job) => job.id === jobFilterId);
    }

    if (jobManagerIds.length) {
      filteredJobList = filteredJobList.filter((job) => jobManagerIds.includes(job.managerId));
    }

    if (jobListType) {
      otherStatusCount = filteredJobList.length;
      filteredJobList = filteredJobList.filter((job) =>
        JOB_LIST_TYPE_TO_JOB_STATUS[jobListType].includes(job.status)
      );
      currentStatusCount = filteredJobList.length;
      otherStatusCount -= currentStatusCount;
    }

    const jobListTypeOptions = JOB_LIST_STATUS_TABS.map((tag) => ({
      value: tag.value,
      label: `${tag.label} ${jobListType === tag.value ? currentStatusCount : otherStatusCount}`,
    }));

    const { currentOrg } = this.props;

    const jobListTableHeaders = [
      {
        key: 'title',
        title: i18n.t`职位名称`,
        width: 206,
        normalCellStyle: true,
        render: (row) => (
          <div className={classNames(styles.title, cms.ellipsis)}>
            {row.followed && <span className={styles.flowLine} />}
            {row.status === 'closed' && <Icon name="banLine" className={sdf.n50} />}
            {row.prior && <Icon name="fire" className={sdf.r60} />}
            {' ' + row.title}
          </div>
        ),
      },
      {
        key: 'managerName',
        dataIndex: 'managerName',
        title: i18n.t`职位负责人`,
        width: 195,
        normalCellStyle: true,
        render: (row) => (
          <Dropdown
            disabled={!currentOrg?.headhunterJobFields?.managerPhone}
            triggerType="hover"
            disabledAutoHide
            placement="top"
            popup={
              <div className={classNames(cms.pdy8, cms.pdx16)}>
                <div className={cms.mgb4}>{row.managerName}</div>
                <div>
                  {i18n.t`手机号：`}
                  {row.managerPhone || i18n.t`暂无`}
                </div>
              </div>
            }
          >
            <span>{row.managerName}</span>
          </Dropdown>
        ),
      },
      {
        key: 'applicationNum',
        title: (
          <div className={cms.pdx16}>
            {i18n.t`已推荐人数`}
            <Tooltip appendBody placement="top" content={i18n.t`包含单个和批量推荐人数`}>
              <Icon className={cms.mgl4} name="info" />
            </Tooltip>
          </div>
        ),
        width: 195,
        normalCellStyle: true,
        render: (row) => (
          <button className={styles.title} onClick={this.onNumClick(row.id)}>
            {row.applicationNum}
          </button>
        ),
      },
      {
        key: 'updatedAt',
        title: i18n.t`更新时间`,
        width: 166,
        normalCellStyle: true,
        render: (row) => moment(row.updatedAt).format(DATE_FORMAT),
      },
      {
        key: 'hireMode',
        title: i18n.t`招聘类型`,
        width: 166,
        normalCellStyle: true,
        render: (row) => (row.hireMode === HIRE_MODES.SOCIAL ? i18n.t`社会招聘` : i18n.t`校园招聘`),
      },
      {
        width: 224,
        title: i18n.t`操作`,
        textAlign: 'right',
        normalCellStyle: true,
        render: (row) => (
          <Spacing spacing="lg">
            {!!row.headhunterEnabled && (
              <Button type="text" size="md" onClick={this.onRecommendClick(row)}>
                {i18n.t`猎头推荐`}
              </Button>
            )}
            {!!row.rpoEnabled && (
              <Button type="text" size="md" onClick={this.onRecommendClick(row, 'rpo')}>
                {i18n.t`RPO推荐`}
              </Button>
            )}
            <Button
              type="text"
              className={classNames(styles.btnFollow, {
                [styles.followed]: row.followed,
              })}
              size="md"
              onClick={this.createOnToggleJob(row.id, row.followed, row.contractId)}
            >
              {!!row.followed && <span className={styles.normal}>{i18n.t`已关注`}</span>}
              {!row.followed && <span className={styles.normal}>{i18n.t`关注`}</span>}
              <span className={styles.cancel}>{i18n.t`取消关注`}</span>
            </Button>
          </Spacing>
        ),
      },
    ];

    return (
      <div className={classNames('orgdetail__content', cms.mgt24)}>
        <Spacing>
          <Spacing direction="vertical">
            <div className={sdf.boldBodySecondary}>{i18n.t`职位`}</div>
            <Select
              searchable
              clearable
              size="md"
              placeholder={i18n.t`请选择职位`}
              value={jobFilterId}
              options={jobFilterOptions}
              onChange={this.onJobFilterChange}
            />
          </Spacing>
          <Spacing direction="vertical">
            <div className={sdf.boldBodySecondary}>{i18n.t`职位负责人`}</div>

            <JobManagerSelect
              value={jobManagerIds}
              options={managerFilterOptions}
              onChange={this.onJobManagerFilterChange}
            />
          </Spacing>
        </Spacing>

        <TagSelect
          className={classNames(cms.block, cms.mgt24, cms.mgb8)}
          options={jobListTypeOptions}
          value={jobListType}
          color="gray"
          onChange={this.onJobFilterStatusChange}
        />
        {jobLoading ? (
          <div className="panel--empty">
            <Loading />
          </div>
        ) : jobList.length === 0 ? (
          <div className="list-empty">
            <Empty title={i18n.t`暂无职位`} />
          </div>
        ) : (
          <NewTable
            width="100%"
            tableAdaptMode="auto"
            columnResizeEnabled
            bordered={false}
            headers={jobListTableHeaders}
            rows={filteredJobList}
            onRowClick={this.onJobClick}
          />
        )}
      </div>
    );
  }
}

JobList.propTypes = {
  jobLoading: PropTypes.bool,
  onRedirectToApplication: PropTypes.func,
  removeJobFollowed: PropTypes.func.isRequired,
  addJobFollowed: PropTypes.func.isRequired,
};

export default connect(null, { fetchJobList })(withRouter(JobList));
